import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CTAButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  size?: "md" | "lg";
};
export function CTAButton({
  label,
  sub,
  id,
  size = "lg"
}: CTAButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-103" data-mp="2fzv0h2egek3m">
      <a id={id} href={CHECKOUT_URL} className={`group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold-400 text-center font-extrabold uppercase tracking-wide text-navy-950 shadow-[0_10px_30px_-8px_rgba(236,191,79,0.7)] ring-2 ring-gold-200/60 transition-[transform,background-color] duration-150 ease-out hover:bg-gold-300 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-white ${size === "lg" ? "px-6 py-5 text-lg sm:text-xl" : "px-5 py-4 text-base sm:text-lg"}`} data-id="element-104" data-mp="2fya4r9gekv46">
        <span className="leading-tight" data-id="element-105" data-mp="38paappyao8yh">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-106" data-mp="198wip3u4l81y" />
      </a>
      {sub && <p className="mt-3 text-center text-sm font-medium opacity-80" data-id="element-107" data-mp="1db06mrxze544">{sub}</p>}
    </div>;
}